export default function loginToWordpress(url, username, password) {
  const body = document.querySelector('body');

  const form = document.createElement('form');
  form.setAttribute('action', `${url}/wp-login.php`);
  form.setAttribute('method', 'POST');
  form.setAttribute('name', 'loginform');

  const usernameField = document.createElement('input');
  usernameField.setAttribute('name', 'log');
  usernameField.setAttribute('type', 'hidden');
  usernameField.value = username;
  form.appendChild(usernameField);

  const passwordField = document.createElement('input');
  passwordField.setAttribute('name', 'pwd');
  passwordField.setAttribute('type', 'hidden');
  passwordField.value = password;
  form.appendChild(passwordField);

  const submitField = document.createElement('input');
  submitField.setAttribute('type', 'submit');
  form.appendChild(submitField);

  body.appendChild(form);

  form.submit();
}



// WEBPACK FOOTER //
// ./app/utils/loginToWordpress.js